import classNames from "classnames";
import Styles from "./Index.module.scss";
import Navbar from "../../Component/Navbar/Navbar";
import Icon from "../../Component/Icon/Icon";
import {
  faBullhorn,
  faList,
  faPeopleGroup,
  faPaperPlane,
  faHandHoldingHeart,
} from "@fortawesome/free-solid-svg-icons";
import SliderConponent from "../../Component/Slider/Slider";
import Title from "../../Component/Text/Title";
import Card1 from "../../Component/Card/Card1";
import img1 from "../../assets/images/index/社工協助.jpg";
import img2 from "../../assets/images/index/交通接送.jpg";
import img3 from "../../assets/images/index/協助困境.jpg";

import aboutUS from "../../assets/images/index/關於我們.jpg";

import socialService1 from "../../assets/images/index/圓夢計畫-1.jpg";
import socialService2 from "../../assets/images/index/幸福2-1.jpg";
import volunteer from "../../assets/images/index/加入我們_2.jpg";

import news1 from "../../assets/images/index/最新消息_1_2025_02_16.jpg";
import news2 from "../../assets/images/index/news/照服員培訓.jpg";
import news4 from "../../assets/images/index/news/20250513.jpg"
import news5 from "../../assets/images/index/news/用心守護每一程.jpg"

import logo from "../../assets/images/logo/LOGO.png";
import Card2 from "../../Component/Card/Card2";
import Button from "../../Component/Button/Button";
import Jumbotron from "../../Component/Jumbotron/Jumbotron";
import Footer from "../../Component/Footer/Footer";
import { useNavigate } from "react-router";
import { useEffect } from "react";

const Index = () => {
  const navigate = useNavigate();

  const serviceCards = [
    {
      img: img1,
      text: "短期臨托",
      to:"/service/短期臨托"
      
    },
    {
      img: img2,
      text: "長照巴士預約",
      to:"/service/長照巴士預約"
    },
    {
      img: img3,
      text: "長照居家\n困境協助",
      to:"/service/長照居家困境協助"
    },
  ];

  const newsCards = [
    {
      img: news5,
      date: "2025-05-22",
      title: "用心守護每一程",
      description: "上車的那一刻，你不只是乘客，而是被用心照顧的旅人。",
    },
    {
      img: news4,
      date: "2025-05-13",
      title: "花蓮縣身心障礙者臨時及短期服務",
      description: "協助家庭照顧者在短期內獲得休息或處理緊急事務，避免照顧壓力過大，並提供身心障礙者安全、適切的照顧環境。歡迎有需求的打電話來諮詢~~我們會派專業社工師去家裡訪視！！",
    },
    {
      img: logo,
      date: "2025-05-09",
      title: "花蓮實體課程開班通知",
      description: "5月失智症課程 & 身心障礙課程 開班啦！(長照積分已通過)",
    },
    // {
    //   img: news2,
    //   date: "2025-02-14",
    //   title: "照顧服務員資格訓練班 熱烈招生中！",
    //   description:
    //     "💡 想投入長照產業，成為專業又有愛心的照顧達人嗎？💡 想學習實用技能，擁有穩定又有前景的工作嗎？",
    // },
    // {
    //   img: news1,
    //   date: "2025-02-16",
    //   title:
    //     "生命最後的旅程 值得被溫柔對待 ｜ 北榮玉里分院攜手社區共築安寧療和照護網",
    //   description:
    //     "本會2月16日在玉里舉辦的長照積分課程圓滿落幕，感謝蘇倩瑩護理長為我們帶來一場專業且深入啟發的課程，深入講解「安寧緩和醫療」與「預立醫療決定」的重要性。",
    // },
  ];

  /**
   * Handing
   */
  const handleNewsClick = () => {
    navigate("/news");
  };

  /**
   * useEffect
   */
  useEffect(()=>{
    console.log("deploy success 1138")
  },[])

  return (
    <div>
      <Navbar />
      {/* 公告注意事項 */}
      <div
        style={{ marginBottom: "1.5vh", paddingTop: "9vh" }}
        className={classNames("container", Styles.announce)}
      >
        <Icon iconName={faBullhorn} />
        <p>防詐不求人，小心最要緊</p>
      </div>

      {/* 輪播圖 */}
      <div style={{ marginBottom: "1.5vh" }}>
        <SliderConponent />
      </div>

      {/* 服務項目 */}
      <div className={classNames("container")} style={{ paddingBottom: "5vh" }}>
        <Title iconName={faList} text="服務項目" />
        <div className={classNames("col-12", Styles.frame)}>
          {serviceCards.map((card1, index) => {
            return (
              <div
                className={classNames(
                  "col-lg-4",
                  "col-md-12",
                  "col-sm-12",
                  Styles.frame
                )}
              >
                <div className={classNames(Styles.frame__card)}>
                  <Card1 img={card1.img} text={card1.text} to={card1.to} />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 最新消息 */}
      <div
        style={{
          paddingTop: "2vh",
          paddingBottom: "2vh",
          backgroundColor: "#FBF6F6",
        }}
      >
        <div className={classNames("container")}>
          <Title iconName={faBullhorn} text="最新消息" />
          <div className={classNames(Styles.frame)}>
            {newsCards.map((card2, index) => {
              return (
                <div
                  onClick={handleNewsClick}
                  className={classNames(
                    "col-lg-4",
                    "col-md-12",
                    "col-sm-12",
                    Styles.frame
                  )}
                >
                  <div className={classNames(Styles.frame__card)}>
                    <Card2
                      img={card2.img}
                      date={card2.date}
                      title={card2.title}
                      description={card2.description}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "3vh",
          }}
        >
          <Button text="看更多" className="primary" to="/news" />
          {/* <Button
            text="看更多"
            className="primary"
            to="https://www.facebook.com/kuangpo0812/"
          /> */}
        </div>
      </div>

      {/* 關於我們 */}
      <div
        style={{
          paddingTop: "2vh",
          paddingBottom: "5vh",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div className={classNames("container")}>
          <Title iconName={faPeopleGroup} text="關於我們" />
          <div className={classNames(Styles.aboutus)}>
            <div
              className={classNames(
                "col-lg-6",
                "col-sm-12",
                "col-md-12",
                Styles.aboutus__wrapper
              )}
            >
              <div
                style={{
                  width: "87vh",
                  height: "58vh",
                  backgroundImage: `url(${aboutUS})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "1.5vh",
                }}
              ></div>
            </div>
            <div
              className={classNames(
                "col-lg-6",
                "col-sm-12",
                "col-md-12",
                Styles.aboutus__wrapper
              )}
            >
              <div>
                <h6 className={classNames(Styles.aboutus__title)}>
                  多一份關心，
                  <br />
                  長者少一份憂心跟病痛
                </h6>
                <p className={classNames(Styles.aboutus__content)}>
                  我們相信，每一位長者和身心障礙者都值得被溫柔以待、被妥善照顧，讓他們能安心在熟悉的土地上安居終老。我們堅持在地服務、在地老化，讓在地人陪伴在地人，共同走過人生的每一個階段，走向長遠而美麗的晚景。同時，我們也致力於滋養在地就業機會，讓壯年者有所用、長者有所養，一起實踐「老有所終」的願望，為這片土地注入持續不斷的關懷與力量。
                </p>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3vh",
            }}
          >
            <Button text="關於我們" className="primary" to="/aboutus" />
          </div>
        </div>
      </div>

      {/* 社會服務 */}
      {/* <div
        style={{
          paddingTop: "2vh",
          paddingBottom: "5vh",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div className={classNames("container")}>
          <Title iconName={faPaperPlane} text="社會服務" />
          <div className={classNames(Styles.aboutus)}>
            <div
              className={classNames(
                "col-lg-6",
                "col-sm-12",
                "col-md-12",
                Styles.aboutus__wrapper
              )}
            >
              <div>
                <h6 className={classNames(Styles.aboutus__title)}>
                  偏鄉身心障礙者或偏鄉老人
                  <br />
                  圓夢計畫
                </h6>
                <ul className={classNames(Styles.aboutus__content)}>
                  <li>成為長輩的貴人幫他們圓夢。</li>
                  <li>讓助人者的快樂感染你我的周圍。</li>
                  <li>可報名直接體驗</li>
                </ul>
              </div>
            </div>
            <div
              className={classNames(
                "col-lg-6",
                "col-sm-12",
                "col-md-12",
                Styles.aboutus__wrapper
              )}
            >
              <div
                style={{
                  width: "87vh",
                  height: "58vh",
                  backgroundImage: `url(${socialService1})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "1.5vh",
                }}
              ></div>
            </div>
          </div>
          <div className={classNames(Styles.aboutus)}>
            <div
              className={classNames(
                "col-lg-6",
                "col-sm-12",
                "col-md-12",
                Styles.aboutus__wrapper
              )}
            >
              <div
                style={{
                  width: "87vh",
                  height: "58vh",
                  backgroundImage: `url(${socialService2})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "1.5vh",
                }}
              ></div>
            </div>
            <div
              className={classNames(
                "col-lg-6",
                "col-sm-12",
                "col-md-12",
                Styles.aboutus__wrapper
              )}
            >
              <div>
                <h6 className={classNames(Styles.aboutus__title)}>
                  幸福二之一
                </h6>
                <ul className={classNames(Styles.aboutus__content)}>
                  <li>偏鄉身障或獨老二天一夜居家服務體驗。</li>
                  <li>為花蓮長者帶來溫暖，服務學習，體驗老化後的生活。</li>
                  <li>可報名直接體驗</li>
                </ul>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3vh",
            }}
          >
            <Button text="看更多" className="primary" to="/service" />
          </div>
        </div>
      </div> */}

      {/* 加入志願者 */}
      <div>
        <Jumbotron
          img={volunteer}
          text={`加入志願者的行列 
          `}
        />
      </div>

      {/* 我要捐款 */}
      <div style={{ display: "none" }}>
        <Title iconName={faHandHoldingHeart} text={`我要捐款`} />
        <div className={classNames("container", Styles.joinus)}>
          <div className={classNames("col-8", Styles.joinus__description)}>
            <p>
              戶名：社團法人中華廣博長照發展協會
              <br />
              銀行匯款：(004) 257001012768
            </p>
          </div>
          <div className={classNames("col-4")}>
            <div className={classNames(Styles.joinus__wrapper)}>
              <img src="https://kuang-bo.s3.ap-southeast-1.amazonaws.com/static/media/LOGO.c0c5a38102d94b82e6fc.png" />
            </div>
          </div>
        </div>
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Index;
